import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";
import { customStyles } from "./DropDownStyles";

export default class ClientSpecificationInput extends React.Component {
  fetchData = search => {
    const { company_id } = this.props;
    return fetchJson("/products/client_specifications.json", { company_id, search }).then(
      records => records.map(m => ({ label: m.name, value: m.id }))
    );
  };

  render() {
    const { onChange, multiple } = this.props;
    return (
      <AsyncSelect
        placeholder={"Select"}
        isMulti={multiple}
        simpleValue={true}
        autoload={true}
        styles={customStyles()}
        id="spec_id"
        loadOptions={this.fetchData}
        defaultOptions={true}
        onChange={onChange}
      />
    );
  }
}
